const contentModule = (state: AnyFixMe) =>
  state.secondaryLeftArea.contentModule;
const width = (state: AnyFixMe) => state.secondaryLeftArea.width;

export { contentModule, width };
